import { Routes, Route, Navigate } from 'react-router-dom';
import Gallery from './components/Gallery';
import Necklaces from './pages/Necklaces';
import Bracelets from './pages/Braclets';
import Earrings from './pages/Earrings';
import App from './App';
import Mainpage from './pages/Mainpage';
import { AppProvider } from './Context/AppContext';

const AppRoutes = () => (
    <AppProvider>
  <Routes>
    <Route path="/" element={<Mainpage />}>
      <Route path="necklaces" element={<Necklaces />} />
      <Route path="bracelets" element={<Bracelets />} />
      <Route path="earrings" element={<Earrings />} />
      <Route path="" element={<Gallery />} />
    </Route>
  </Routes>
  </AppProvider>
);

export default AppRoutes;